import { render, staticRenderFns } from "./SectionHome.vue?vue&type=template&id=1928184b&"
import script from "./SectionHome.vue?vue&type=script&lang=js&"
export * from "./SectionHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Logo: require('/private/var/folders/c0/mk3zh23n40nd2cwxybf80c0h0000gn/T/ltng/components/Logo.vue').default})
